import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase";
import { collection, getDocs, query } from "firebase/firestore";

export const fetchBusinessData = createAsyncThunk(
  "business/fetchBusinessData",
  async () => {
    const q = query(collection(db, "business_data"));

    const querySnapshot = await getDocs(q);
    const items = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // console.log("fetchBusinessData : ", items);
    return items[0];
  }
);

export const businessSlice = createSlice({
  name: "business",
  initialState: {
    data: {},
    loading: true,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBusinessData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default businessSlice.reducer;
